/* eslint-disable import/order */
/* eslint-disable max-len */
import {Box, Card, CardContent, CardHeader, Grid, styled} from '@material-ui/core';
import {FiberManualRecord} from '@material-ui/icons';
import Banners from 'components/banners';
import Carousel from 'views/home/supervisor-home/banners/index.js'
import Button from 'components/button';
import ProductGrid from 'components/product-grid';
import {BorderLinearProgress} from 'components/progress/border-linear-progress';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import Spinner from 'components/spinner';
import CreditsTable from 'components/tables/credits-table';
import OrdersTable from 'components/tables/orders-table';
import Text from 'components/text';
import ViewAllProductsLink from 'components/view-all-products-link';
import {reverse} from 'core/urls';
import {checkPermission, formatDateTime, formatMoney} from 'core/utils';
import creditsQuery from 'graphql/queries/credits.gql';
import featuredProductsQuery from 'graphql/queries/featured-products.gql';
import React, {Component, Fragment} from 'react';
import {compose, graphql} from 'react-apollo';
import styles from './styles.css';

@compose(
    graphql(creditsQuery, {
        name: 'creditsData',
        options: props => ({
            variables: {organization: props.user.organization.id},
        }),
    }),
    graphql(featuredProductsQuery, {name: 'featuredProductsData'}),
)
export default class OrganizationHome extends Component {
    /** @type {{tab: 'lastMovements' | 'orders'}} */
    state = {
        tab: 'orders',
    };

    /** @type {{ creditsData: Array<any>}} */
    props = {};

    /** @param {Tab} value */
    createTabChangeHandler(value) {
        return () => this.setState({tab: value});
    }

    render() {
        const loading = this.props.creditsData.loading
            || this.props.featuredProductsData.loading;

        if (loading) return <Spinner />;
        const showCreditSummary = this.props.user.organization.createDealerOrders;
        return (
            <div className={styles.root}>
                <div className={styles.background} />
                <SectionBanner />
                {showCreditSummary && (
                    <Box>
                        <Card elevation={0} variant='outlined'>
                            <CardHeader
                                title={<Text variant='h2' bold='bolder'>{this.props.user.organization.name}</Text>}
                                disableTypography
                            />
                            <CardContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} container justify='space-between' spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Text variant='h2'>Resumen del crédito</Text>
                                            <Text variant='h2' bold='bold'>Total: {formatMoney(this.props.creditsData.creditSummary, 'total')}</Text>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Text align='right'>
                                                Ultima actualización: <strong>{formatDateTime(this.props.creditsData.creditSummary.lastUpdate)}</strong>
                                            </Text>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container spacing={2}>
                                        <Grid item xs={12}>
                                            <BorderLinearProgress
                                                variant='determinate'
                                                height={16}
                                                value={this.props.creditsData.creditSummary.availablePercentage}
                                                color='primary'
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm='auto'>
                                            <Text component='span'>
                                                <FiberManualRecord color='primary' style={{verticalAlign: 'sub'}} />
                                                &nbsp;Disponible&nbsp;
                                                <strong>
                                                    {formatMoney(this.props.creditsData.creditSummary, 'available')}
                                                    &nbsp;({this.props.creditsData.creditSummary.availablePercentage}%)
                                                </strong>
                                            </Text>
                                        </Grid>
                                        <Grid item xs={12} sm='auto'>
                                            <Text component='span'>
                                                <FiberManualRecord color='disabled' style={{verticalAlign: 'sub'}} />
                                                &nbsp;Consumido&nbsp;
                                                <strong>
                                                    {formatMoney(this.props.creditsData.creditSummary, 'consumed')}
                                                    &nbsp;({this.props.creditsData.creditSummary.consumedPercentage}%)
                                                </strong>
                                            </Text>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Text variant='subtitle1'>Te recordamos que los créditos son estimados en función de tú objetivo y en base a un precio promedio por bolsa</Text>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>
                )}
                <Card elevation={0} variant='outlined' style={{position: 'relative', overflow: 'visible', paddingTop: 10}}>
                    <FloatingTabs>
                        <Tab onClick={this.createTabChangeHandler('orders')} selected={this.state.tab === 'orders'}>Pedidos Realizados</Tab>
                        <Tab onClick={this.createTabChangeHandler('lastMovements')} selected={this.state.tab === 'lastMovements'}>Ultimos Movimientos</Tab>
                    </FloatingTabs>
                    <CardHeader
                        disableTypography
                        title={
                            <Text variant='h2' bold='bolder'>
                                {this.state.tab === 'lastMovements'
                                    ? 'Movimientos'
                                    : 'Pedidos realizados'
                                }
                            </Text>
                        }
                    />
                    <CardContent>
                        {this.state.tab === 'lastMovements' && (
                            <Fragment>
                                <CreditsTable data={this.props.creditsData.transactions} />
                                <Box display='flex' flexDirection='row-reverse'>
                                    <Button
                                        link={reverse('creditSummary', {id: this.props.user.organization.id})}
                                        theme='yellow'>
                                        Ver todos mis movimientos
                                    </Button>
                                </Box>
                            </Fragment>
                        )}
                        {this.state.tab === 'orders' && (
                            <Fragment>
                                <OrdersTable />
                                <Box display='flex' flexDirection='row-reverse'>
                                    <Button link={reverse('orderList')} theme='yellow'>Ver todos los pedidos</Button>
                                </Box>
                            </Fragment>
                        )}
                    </CardContent>
                </Card>
                <Grid item xs={12} className={styles.banner}>
                    <Carousel/>
                </Grid>
                {checkPermission(this.props.user, 'merchandising') && (
                    <Fragment>
                        <div className={styles.newProducts}>
                            <SectionTitle title='Nuevos productos' />
                            <ProductGrid products={this.props.featuredProductsData.featuredProducts} />
                            <ViewAllProductsLink />
                        </div>
                        <Banners noCredit />
                    </Fragment>
                )}
            </div>
        );
    }
}

const FloatingTabs = styled('div')(({theme}) => ({
    position: 'absolute',
    top: 0,
    right: '50%',
    transform: 'translateY(-50%) translateX(50%)',
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: theme.spacing(1),
    width: 'fit-content',
    padding: theme.spacing(0.5),
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    columnGap: theme.spacing(1),
}));

const Tab = styled('button')(({theme, ...props}) => ({
    backgroundColor: props.selected && theme.palette.primary.main || 'unset',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1, 5),
}));



// WEBPACK FOOTER //
// ./views/home/organization-home/index.js